import { render } from "./McustomerIndex.vue?vue&type=template&id=316700bc&scoped=true"
import script from "./McustomerIndex.vue?vue&type=script&lang=js"
export * from "./McustomerIndex.vue?vue&type=script&lang=js"

import "./McustomerIndex.vue?vue&type=style&index=0&id=316700bc&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316700bc"]])

export default __exports__